export default "__VITE_ASSET__48a62b5d__"